import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-import-types',
    templateUrl: './import-types.component.html',
    styleUrls: ['./import-types.component.scss'],
    providers: [ImportTypeService],
    standalone: false
})
export class ImportTypesComponent implements OnInit {

  public title = 'All Import types';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title' }
  ];

  constructor(public importTypeService: ImportTypeService, private router: Router) {
  }

  ngOnInit() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Type',
        callback: () => {
          this.router.navigate(['import-types/create']);
        }
      })
    ];
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['import-types', event.row._id]);
  }

}
